import { MODEL_KEY } from '../../../model'

export const EXERCISE_DETAILS_KEY = {
  ...MODEL_KEY,

  HOW_TO_DO: 'howToDo',
  BENEFITS: 'benefits',
  TIPS: 'tips',
  LANGUAGE_CODE: 'languageCode',

  // Foreign keys
  EXERCISE_ID: 'exerciseId'
}

export const EXERCISE_DETAILS_PRIVATE_KEYS = []

export const EXERCISE_DETAILS_CLASS_NAME = 'ExerciseDetails'

export const EXERCISE_DETAILS_ASSOCIATION_KEYS = []

export const EXERCISE_DETAILS_AUDIT = {
  CREATED: 'ExerciseDetails Created',
  UPDATED: 'ExerciseDetails Updated'
}

export const EXERCISE_DETAILS_SCOPE = {
  defaultScope: {
    attributes: {
      exclude: EXERCISE_DETAILS_PRIVATE_KEYS
    }
  }
}
